"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteEditorSuccess = exports.siteEditorReset = exports.siteEditorFind = exports.siteEditorError = exports.siteEditorEditRecord = exports.siteEditorEdit = exports.siteEditorDelete = exports.siteEditorChangeBrand = void 0;
var _siteEditor = require("./siteEditor.constant");
// @flow

// common success
var siteEditorSuccess = function siteEditorSuccess(actionType, data) {
  return {
    type: _siteEditor.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.siteEditorSuccess = siteEditorSuccess;
var siteEditorError = function siteEditorError(actionType, error) {
  return {
    type: _siteEditor.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * editor delete
 * @param payload
 * @returns api response
 * @description this function used to editor delete.
 */
exports.siteEditorError = siteEditorError;
var siteEditorDelete = function siteEditorDelete(data) {
  return {
    type: _siteEditor.actionTypes.DELETE,
    payload: data
  };
};

/**
 * editor change brand
 * @param payload
 * @returns api response
 * @description this function used to change brand.
 */
exports.siteEditorDelete = siteEditorDelete;
var siteEditorChangeBrand = function siteEditorChangeBrand(data) {
  return {
    type: _siteEditor.actionTypes.CHANGE_BRAND,
    payload: data
  };
};

/**
 * editor edit
 * @param payload
 * @returns api response
 * @description this function used to edit.
 */
exports.siteEditorChangeBrand = siteEditorChangeBrand;
var siteEditorEdit = function siteEditorEdit(data) {
  return {
    type: _siteEditor.actionTypes.EDIT,
    payload: data
  };
};

/**
 * editor find
 * @param payload
 * @returns api response
 * @description this function used to find.
 */
exports.siteEditorEdit = siteEditorEdit;
var siteEditorFind = function siteEditorFind(data) {
  return {
    type: _siteEditor.actionTypes.FIND,
    payload: data
  };
};

/**
 * edit record
 * @param payload
 * @returns api response
 * @description this function used to edit record.
 */
exports.siteEditorFind = siteEditorFind;
var siteEditorEditRecord = function siteEditorEditRecord(payload) {
  return {
    type: _siteEditor.actionTypes.EDIT_RECORD,
    payload: payload
  };
};

/**
 * edit record reset
 * @param payload
 * @returns api response
 * @description this function used to edit record reset.
 */
exports.siteEditorEditRecord = siteEditorEditRecord;
var siteEditorReset = function siteEditorReset() {
  return {
    type: _siteEditor.actionTypes.RESET
  };
};
exports.siteEditorReset = siteEditorReset;